// extracted by mini-css-extract-plugin
export var createdDate = "_kd-1";
export var divider = "_kd-2";
export var headerDivider = "_kd-3";
export var messagesCard = "_kd-0";
export var messagesContainer = "_kd-6";
export var messagesContainerWrapper = "_kd-4";
export var showLeftPanelButton = "_kd-8";
export var topButtons = "_kd-7";
export var withPadding = "_kd-5";